/**
 * Logo-glass — mouse-parallax on the timeline's final-chapter decorative
 * mark (see template-parts/components/timeline-item-final.php,
 * src/sass/theme/_timeline.scss .timeline__glass-logo*).
 *
 * Adapts dots-pattern.js's pointer-tracking + IntersectionObserver-gated
 * requestAnimationFrame pattern, but drives transform: translate3d() on 3
 * stacked, identically-masked layers instead of a canvas render — a real
 * DOM-transform parallax needs a per-layer translate, which a canvas
 * heat-map loop doesn't produce.
 *
 * Desktop-only (matches src/js/timeline.js's own >=992px breakpoint, where
 * the pinned/hoverable layout lives) and no-ops entirely under
 * prefers-reduced-motion — the gradient-shift animation is separately
 * frozen via CSS (_timeline.scss's reduced-motion block).
 */
(function () {
	'use strict';

	var container = document.querySelector( '.js-glass-logo' );
	if ( ! container ) {
		return;
	}

	var layers = Array.prototype.slice.call( container.querySelectorAll( '.js-glass-logo-layer' ) );
	if ( ! layers.length ) {
		return;
	}

	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return; // static CSS state only
	}

	if ( ! window.matchMedia( '(min-width: 992px)' ).matches ) {
		return; // parallax is a hover-cursor enhancement, meaningless on touch/mobile
	}

	// Per-layer max travel in px at full pointer excursion, back → front —
	// nearer layers move more, reinforcing the depth illusion.
	var MAX_TRAVEL = [ 6, 12, 20 ];
	var LERP = 0.08;

	var target = { x: 0, y: 0 }; // normalized -1..1 offset from container center
	var current = { x: 0, y: 0 };
	var rafId = null;
	var visible = false;

	function onPointerMove( e ) {
		var rect = container.getBoundingClientRect();
		var cx = rect.left + rect.width / 2;
		var cy = rect.top + rect.height / 2;
		target.x = Math.max( -1, Math.min( 1, ( e.clientX - cx ) / ( rect.width / 2 || 1 ) ) );
		target.y = Math.max( -1, Math.min( 1, ( e.clientY - cy ) / ( rect.height / 2 || 1 ) ) );
	}

	function render() {
		current.x += ( target.x - current.x ) * LERP;
		current.y += ( target.y - current.y ) * LERP;

		for ( var i = 0; i < layers.length; i++ ) {
			var travel = MAX_TRAVEL[ i ] || MAX_TRAVEL[ MAX_TRAVEL.length - 1 ];
			layers[ i ].style.transform = 'translate3d(' + ( current.x * travel ).toFixed( 2 ) + 'px, ' + ( current.y * travel ).toFixed( 2 ) + 'px, 0)';
		}

		rafId = requestAnimationFrame( render );
	}

	function wake() {
		if ( ! visible || rafId !== null ) {
			return;
		}
		rafId = requestAnimationFrame( render );
	}

	window.addEventListener( 'mousemove', onPointerMove );
	window.addEventListener( 'mouseleave', function () {
		target.x = 0;
		target.y = 0; // recenters the layers rather than parking them off-canvas
	} );

	// Animate only while the chapter is actually in view — all timeline
	// chapters stay mounted in the DOM the whole time (src/js/timeline.js),
	// so without this the loop would run continuously regardless of scroll.
	var observer = new IntersectionObserver( function ( entries ) {
		entries.forEach( function ( entry ) {
			if ( entry.isIntersecting ) {
				visible = true;
				wake();
			} else {
				visible = false;
				if ( rafId !== null ) {
					cancelAnimationFrame( rafId );
					rafId = null;
				}
			}
		} );
	}, { threshold: 0 } );
	observer.observe( container );
}());
